(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[13],{

/***/ "RhWx":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("tGbD");

var iterableToArray = __webpack_require__("twbh");

var unsupportedIterableToArray = __webpack_require__("peMk");

var nonIterableSpread = __webpack_require__("d8WC");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "Z79w":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1t7P");

__webpack_require__("2G9S");

__webpack_require__("LW0h");

__webpack_require__("jwue");

__webpack_require__("z84I");

__webpack_require__("daRM");

__webpack_require__("FtHn");

__webpack_require__("+KXO");

__webpack_require__("+oxZ");

var _toConsumableArray = __webpack_require__("RhWx");

var _defineProperty = __webpack_require__("KEM+");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/*

Tailwind - The Utility-First CSS Framework

A project by Adam Wathan (@adamwathan), Jonathan Reinink (@reinink),
David Hemphill (@davidhemphill) and Steve Schoger (@steveschoger).

Welcome to the Tailwind config file. This is where you can customize
Tailwind specifically for your project. Don't be intimidated by the
length of this file. It's really just a big JavaScript object and
we've done our very best to explain each section.

View the full documentation at https://tailwindcss.com.


|-------------------------------------------------------------------------------
| The default config
|-------------------------------------------------------------------------------
|
| This variable contains the default Tailwind config. You don't have
| to use it, but it can sometimes be helpful to have available. For
| example, you may choose to merge your custom configuration
| values with some of the Tailwind defaults.
|
*/
// let defaultConfig = require('tailwindcss/defaultConfig')

/*
|-------------------------------------------------------------------------------
| Colors                                    https://tailwindcss.com/docs/colors
|-------------------------------------------------------------------------------
|
| Here you can specify the colors used in your project. To get you started,
| we've provided a generous palette of great looking colors that are perfect
| for prototyping, but don't hesitate to change them for your project. You
| own these colors, nothing will break if you change everything about them.
|
| We've used literal color names ("red", "blue", etc.) for the default
| palette, but if you'd rather use functional names like "primary" and
| "secondary", or even a numeric scale like "100" and "200", go for it.
|
*/


var colors = {
  current: 'currentColor',
  transparent: 'transparent',
  inherit: 'inherit',

  /* Brand colors */
  amber: 'hsla(29, 94%, 37%, 1)',
  // #b95e06
  'amber-active': 'hsla(29, 99%, 42%, 1)',
  ardoise: 'hsla(215, 19%, 43%, 1)',
  // #596A82
  'ardoise-active': 'hsla(215, 35%, 43%, 1)',
  blue: 'hsla(203, 100%, 27%, 1)',
  // #005589
  'blue-active': 'hsla(195, 95%, 34%, 1)',
  deepBlue: 'hsla(216, 100%, 18%, 1)',
  // #00265e : web declinaison of #235578
  'deepBlue-active': 'hsla(216, 100%, 21%, 1)',
  gold: 'hsla(43, 66%, 35%, 1)',
  // #93721e
  'gold-active': 'hsla(43, 76%, 35%, 1)',
  gray: 'hsla(0, 0%, 27%, 1)',
  // #444444
  'gray-active': 'hsla(0, 0%, 37%, 1)',
  grenadine: 'hsla(339, 49%, 54%, 1)',
  // #c35078
  'grenadine-active': 'hsla(339, 59%, 54%, 1)',
  kiwi: 'hsla(58, 71%, 29%, 1)',
  // #7D7A15
  'kiwi-active': 'hsla(58, 81%, 29%, 1)',
  lilas: 'hsla(218, 38%, 52%, 1)',
  // #5477B3
  'lilas-active': 'hsla(218, 48%, 52%, 1)',
  mahogany: 'hsla(337, 62%, 21%, 1)',
  // #55142d
  'mahogany-active': 'hsla(337, 82%, 21%, 1)',
  nude: 'hsla(36, 45%, 78%, 1)',
  // #E1CDAF
  'nude-active': 'hsla(36, 65%, 78%, 1)',
  ocher: 'hsla(40, 87%, 33%, 1)',
  // #9F6D0B
  'ocher-active': 'hsla(40, 97%, 33%, 1)',
  pine: 'hsla(185, 60%, 20%, 1)',
  // #144b50
  'pine-active': 'hsla(185, 80%, 20%, 1)',
  platinum: 'hsla(0, 0%, 0%, 1)',
  // #000000
  'platinum-active': 'hsla(0, 0%, 0%, 1)',
  prune: 'hsla(312, 67%, 24%, 1)',
  // #671456 : web declinaison of #4b2355
  'prune-active': 'hsla(312, 87%, 24%, 1)',
  sand: 'hsla(41, 50%, 69%, 1)',
  // #d7be87
  'sand-active': 'hsla(41, 60%, 69%, 1)',
  sandPearl: 'hsla(36, 45%, 89%, 1)',
  // #f0e6d7
  'sandPearl-active': 'hsla(36, 55%, 89%, 1)',
  silver: 'hsla(220, 2%, 70%, 1)',
  // #b1b2b4
  'silver-active': 'hsla(220, 12%, 70%, 1)',
  skyBlue: 'hsla(185, 44%, 72%, 1)',
  // #97d2d7
  'skyBlue-active': 'hsla(185, 54%, 72%, 1)',
  southSea: 'hsla(186, 33%, 71%, 1)',
  // #9bc8cd
  'southSea-active': 'hsla(186, 43%, 71%, 1)',
  turquoise: 'hsla(195, 95%, 34%, 1)',
  // #0480a9 : web declinaison of #78b4c3
  'turquoise-active': 'hsla(195, 100%, 39%, 1)',
  waterGreen: 'hsla(178, 100%, 23%, 1)',
  // #007672
  'waterGreen-active': 'hsla(178, 100%, 33%, 1)',
  happyToCare: 'hsla(152.877, 38.2%, 37.5%, 1)',
  // #3b8463
  'happyToCare-active': 'hsla(152.877, 38.2%, 40%, 1)',

  /* Additional colors */
  black: 'hsla(0, 0%, 0%, 1)',
  // #000000
  deepRed: 'hsla(0, 70%, 45%, 1)',
  // #c42323
  'deepRed-active': 'hsla(0, 80%, 45%, 1)',
  emerald: '#088a20',
  'emerald-active': 'hsla(131, 99%, 29%, 1)',
  orange: 'hsla(12, 66%, 49%, 1)',
  // #cf4a2a
  'orange-active': 'hsla(12, 76%, 49%, 1)',
  red: '#d64040',
  'red-active': 'hsla(0, 74%, 55%, 1)',
  yellow: 'hsla(51, 93%, 58%, 1)',
  // #F7D831
  white: 'hsla(0, 100%, 100%, 1)',
  // #ffffff

  /* Gray colors */
  'gray-lighter': '#f7f7f7',
  'gray-light': '#d4d1d1',
  'gray-medium': '#a8a0a0',
  'gray-medium-dark': '#797676',
  'gray-dark': '#998e8e',
  'gray-darker': '#504747'
};
var globalSpacing = {
  0: '0',
  px: '1px',
  px5: '.3125rem',
  // 5px
  px10: '.625rem',
  // 10px
  px15: '.9375rem',
  // 15px
  px20: '1.25rem',
  // 20px
  px25: '1.5625rem',
  // 25px
  px30: '1.875rem',
  // 30px
  px40: '2.5rem',
  // 40px
  px50: '3.125rem',
  // 50px
  px60: '3.75rem',
  // 60px
  px80: '5rem',
  // 80px
  px95: '5.9375rem',
  // 95px
  32: '9rem' // 144px

};
var negativeGlobalSpacing = {
  '-px': '-1px',
  '-px5': '-0.3125rem',
  // 5px
  '-px10': '-0.625rem',
  // 10px
  '-px15': '-0.9375rem',
  // 15px
  '-px20': '-1.25rem',
  // 20px
  '-px25': '-1.5625rem',
  // 25px
  '-px30': '-1.875rem',
  // 30px
  '-px40': '-2.5rem',
  // 40px
  '-px50': '-3.125rem',
  // 50px
  '-px60': '-3.75rem' // 60px

}; // NOTE: We use module.exports here because it is actually a config file u_u.
// eslint-disable-next-line import/no-commonjs

module.exports = {
  /*
    |-----------------------------------------------------------------------------
    | Advanced Options         https://tailwindcss.com/docs/configuration#options
    |-----------------------------------------------------------------------------
    |
    | Here is where you can tweak advanced configuration options. We recommend
    | leaving these options alone unless you absolutely need to change them.
    |
    */
  prefix: '',
  important: false,
  separator: ':',
  colors: colors,
  plugins: [// rtl
  function (_ref) {
    var e = _ref.e,
        addUtilities = _ref.addUtilities;
    var rtlSpacing = Object.keys(globalSpacing).map(function (key) {
      var _ref2;

      return _ref2 = {}, _defineProperty(_ref2, "body:not([dir=\"rtl\"]) .".concat(e("rtl:ml-".concat(key))), {
        marginLeft: globalSpacing[key]
      }), _defineProperty(_ref2, "body[dir=\"rtl\"] .".concat(e("rtl:ml-".concat(key))), {
        marginRight: globalSpacing[key]
      }), _defineProperty(_ref2, "body:not([dir=\"rtl\"]) .".concat(e("rtl:mr-".concat(key))), {
        marginRight: globalSpacing[key]
      }), _defineProperty(_ref2, "body[dir=\"rtl\"] .".concat(e("rtl:mr-".concat(key))), {
        marginLeft: globalSpacing[key]
      }), _defineProperty(_ref2, "body:not([dir=\"rtl\"]) .".concat(e("rtl:-ml-".concat(key))), {
        marginLeft: "-".concat(globalSpacing[key])
      }), _defineProperty(_ref2, "body[dir=\"rtl\"] .".concat(e("rtl:-ml-".concat(key))), {
        marginRight: "-".concat(globalSpacing[key])
      }), _defineProperty(_ref2, "body:not([dir=\"rtl\"]) .".concat(e("rtl:-mr-".concat(key))), {
        marginRight: "-".concat(globalSpacing[key])
      }), _defineProperty(_ref2, "body[dir=\"rtl\"] .".concat(e("rtl:-mr-".concat(key))), {
        marginLeft: "-".concat(globalSpacing[key])
      }), _ref2;
    });
    var rtlPadding = Object.keys(globalSpacing).map(function (key) {
      var _ref3;

      return _ref3 = {}, _defineProperty(_ref3, "body:not([dir=\"rtl\"]) .".concat(e("rtl:pl-".concat(key))), {
        paddingLeft: globalSpacing[key]
      }), _defineProperty(_ref3, "body[dir=\"rtl\"] .".concat(e("rtl:pl-".concat(key))), {
        paddingRight: globalSpacing[key]
      }), _defineProperty(_ref3, "body:not([dir=\"rtl\"]) .".concat(e("rtl:pr-".concat(key))), {
        paddingRight: globalSpacing[key]
      }), _defineProperty(_ref3, "body[dir=\"rtl\"] .".concat(e("rtl:pr-".concat(key))), {
        paddingLeft: globalSpacing[key]
      }), _ref3;
    });
    var rtlSpacingAuto = [// margin-left
    _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:ml-auto')), {
      marginLeft: 'auto'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:ml-auto')), {
      marginRight: 'auto'
    }), // margin-right
    _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:mr-auto')), {
      marginRight: 'auto'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:mr-auto')), {
      marginLeft: 'auto'
    })];
    var rtlPins = [// left
    _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:left-0')), {
      left: 0
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:left-0')), {
      right: 0
    }), _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:left-auto')), {
      left: 'auto'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:left-auto')), {
      right: 'auto'
    }), // right
    _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:right-0')), {
      right: 0
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:right-0')), {
      left: 0
    }), _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:right-auto')), {
      right: 'auto'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:right-auto')), {
      left: 'auto'
    })];
    var rtlTextAlign = [// text-left
    _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:text-left')), {
      'text-align': 'left'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:text-left')), {
      'text-align': 'right'
    }), // text-right
    _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:text-right')), {
      'text-align': 'right'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:text-right')), {
      'text-align': 'left'
    })];
    var rtlFlexRow = [_defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:flex-row')), {
      'flex-direction': 'row'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:flex-row')), {
      'flex-direction': 'row-reverse'
    })];
    var rtlBorder = [_defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:border-l-1')), {
      'border-left-width': '1px'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:border-l-1')), {
      'border-right-width': '1px'
    }), _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:border-r-1')), {
      'border-right-width': '1px'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:border-r-1')), {
      'border-left-width': '1px'
    })];
    var rtlBorderRadius = [_defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:rounded-l')), {
      borderRadius: '.5rem 0 0 .5rem'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:rounded-l')), {
      borderRadius: '0 .5rem .5rem 0'
    }), _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:rounded-r')), {
      borderRadius: '0 .5rem .5rem 0'
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:rounded-r')), {
      borderRadius: '.5rem 0 0 .5rem'
    }), _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:rounded-l-none')), {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:rounded-l-none')), {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }), _defineProperty({}, "body:not([dir=\"rtl\"]) .".concat(e('rtl:rounded-r-none')), {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0
    }), _defineProperty({}, "body[dir=\"rtl\"] .".concat(e('rtl:rounded-r-none')), {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0
    })];
    addUtilities([].concat(_toConsumableArray(rtlSpacing), rtlSpacingAuto, rtlPins, rtlTextAlign, rtlFlexRow, rtlBorder, _toConsumableArray(rtlPadding), rtlBorderRadius), {
      variants: ['responsive']
    });
  }],
  theme: {
    /*
    |-----------------------------------------------------------------------------
    | Colors                                  https://tailwindcss.com/docs/colors
    |-----------------------------------------------------------------------------
    |
    | The color palette defined above is also assigned to the "colors" key of
    | your Tailwind theme. This makes it easy to access them in your CSS
    | using Tailwind's theme helper. For example:
    |
    | .error { color: theme('colors.red') }
    |
    */
    colors: colors,

    /*
    |-----------------------------------------------------------------------------
    | Screens                      https://tailwindcss.com/docs/responsive-design
    |-----------------------------------------------------------------------------
    |
    | Screens in Tailwind are translated to CSS media queries. They define the
    | responsive breakpoints for your project. By default Tailwind takes a
    | "mobile first" approach, where each screen size represents a minimum
    | viewport width. Feel free to have as few or as many screens as you
    | want, naming them in whatever way you'd prefer for your project.
    |
    | Tailwind also allows for more complex screen definitions, which can be
    | useful in certain situations. Be sure to see the full responsive
    | documentation for a complete list of options.
    |
    | Class name: .{screen}:{utility}
    |
    */
    screens: {
      sm: '40.01em'
      /* 640px --r-minS (phablet) */
      ,
      md: '50.01em'
      /* 800px --r-minM (tablet) */
      ,
      lg: '64.01em'
      /* 1024px --r-minL (desktop) */

    },

    /*
    |-----------------------------------------------------------------------------
    | Fonts                                    https://tailwindcss.com/docs/fonts
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your project's font stack, or font families.
    | Keep in mind that Tailwind doesn't actually load any fonts for you.
    | If you're using custom fonts you'll need to import them prior to
    | defining them here.
    |
    | By default we provide a native font stack that works remarkably well on
    | any device or OS you're using, since it just uses the default fonts
    | provided by the platform.
    |
    | Class name: .font-{name}
    |
    */
    fontFamily: {
      brand: ['Trident', 'HappinessBeta', 'HappinessBeta-New', 'HappinessBeta wf', 'Verdana', 'Arial', 'sans-serif'],
      sans: ['Trident', 'Trebuchet MS', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
      serif: ['Trident', 'Gentium Basic', 'Gentium Basic wf', 'Times New Roman', 'Times', 'serif']
    },

    /*
    |-----------------------------------------------------------------------------
    | Text sizes                         https://tailwindcss.com/docs/text-sizing
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your text sizes. Name these in whatever way
    | makes the most sense to you. We use size names by default, but
    | you're welcome to use a numeric scale or even something else
    | entirely.
    |
    | By default Tailwind uses the "rem" unit type for most measurements.
    | This allows you to set a root font size which all other sizes are
    | then based on. That said, you are free to use whatever units you
    | prefer, be it rems, ems, pixels or other.
    |
    | Class name: .text-{size}
    |
    */
    fontSize: {
      xxs: '.5rem',
      // 8px
      xs: '.625rem',
      // 10px
      sm: '.75rem',
      // 12px
      base: '.875rem',
      // 14px
      md: '1rem',
      // 16px
      lg: '1.125rem',
      // 18px
      xl: '1.25rem',
      // 20px
      '2xl': '1.5rem',
      // 24px
      '3xl': '1.75rem',
      // 28px
      '4xl': '2rem',
      // 32px
      '5xl': '2.25rem',
      // 36px
      '6xl': '2.5rem',
      // 40px
      '7xl': '2.75rem',
      // 44px
      '11xl': '3.75rem',
      // 60px
      '15xl': '4.75rem' // 76px

    },

    /*
    |-----------------------------------------------------------------------------
    | Font weights                       https://tailwindcss.com/docs/font-weight
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your font weights. We've provided a list of
    | common font weight names with their respective numeric scale values
    | to get you started. It's unlikely that your project will require
    | all of these, so we recommend removing those you don't need.
    |
    | Class name: .font-{weight}
    |
    */
    fontWeight: {
      normal: 400,
      bold: 700
    },

    /*
    |-----------------------------------------------------------------------------
    | Leading (line height)              https://tailwindcss.com/docs/line-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your line height values, or as we call
    | them in Tailwind, leadings.
    |
    | Class name: .leading-{size}
    |
    */
    lineHeight: {
      none: 0,
      one: 1,
      tight: 1.2,
      normal: 1.5,
      loose: 1.8
    },

    /*
    |-----------------------------------------------------------------------------
    | Tracking (letter spacing)       https://tailwindcss.com/docs/letter-spacing
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your letter spacing values, or as we call
    | them in Tailwind, tracking.
    |
    | Class name: .tracking-{size}
    |
    */
    letterSpacing: {
      tight: '-0.05em'
    },

    /*
    |-----------------------------------------------------------------------------
    | Text colors                         https://tailwindcss.com/docs/text-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your text colors. By default these use the
    | color palette we defined above, however you're welcome to set these
    | independently if that makes sense for your project.
    |
    | Class name: .text-{color}
    |
    */
    textColor: function textColor(theme) {
      return theme('colors');
    },

    /*
    |-----------------------------------------------------------------------------
    | Background colors             https://tailwindcss.com/docs/background-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your background colors. By default these use
    | the color palette we defined above, however you're welcome to set
    | these independently if that makes sense for your project.
    |
    | Class name: .bg-{color}
    |
    */
    backgroundColor: function backgroundColor(theme) {
      return theme('colors');
    },

    /*
    |-----------------------------------------------------------------------------
    | Background sizes               https://tailwindcss.com/docs/background-size
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your background sizes. We provide some common
    | values that are useful in most projects, but feel free to add other sizes
    | that are specific to your project here as well.
    |
    | Class name: .bg-{size}
    |
    */
    backgroundSize: {
      cover: 'cover'
    },

    /*
    |-----------------------------------------------------------------------------
    | Border widths                     https://tailwindcss.com/docs/border-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border widths. Take note that border
    | widths require a special "default" value set as well. This is the
    | width that will be used when you do not specify a border width.
    |
    | Class name: .border{-side?}{-width?}
    |
    */
    borderWidth: {
      "default": '1px',
      0: '0',
      1: '1px',
      2: '2px',
      5: '5px',
      arrow: '0.5rem',
      'arrow-large': '1rem',
      'arrow-small': '0.25rem'
    },

    /*
    |-----------------------------------------------------------------------------
    | Border colors                     https://tailwindcss.com/docs/border-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border colors. By default these use the
    | color palette we defined above, however you're welcome to set these
    | independently if that makes sense for your project.
    |
    | Take note that border colors require a special "default" value set
    | as well. This is the color that will be used when you do not
    | specify a border color.
    |
    | Class name: .border-{color}
    |
    */
    borderColor: function borderColor(theme) {
      return _objectSpread({
        "default": theme('colors.grey-light')
      }, theme('colors'));
    },

    /*
    |-----------------------------------------------------------------------------
    | Border radius                    https://tailwindcss.com/docs/border-radius
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border radius values. If a `default` radius
    | is provided, it will be made available as the non-suffixed `.rounded`
    | utility.
    |
    | If your scale includes a `0` value to reset already rounded corners, it's
    | a good idea to put it first so other values are able to override it.
    |
    | Class name: .rounded{-side?}{-size?}
    |
    */
    borderRadius: {
      none: '0',
      tiny: '.125rem',
      // 2px
      small: '.3125rem',
      // 5px
      "default": '.5rem',
      // 8px
      large: '1.5rem',
      // 24px
      half: '50%',
      full: '100%'
    },

    /*
    |-----------------------------------------------------------------------------
    | Width                                    https://tailwindcss.com/docs/width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your width utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based numeric scale, a percentage
    | based fraction scale, plus some other common use-cases. You
    | can, of course, modify these values as needed.
    |
    |
    | It's also worth mentioning that Tailwind automatically escapes
    | invalid CSS class name characters, which allows you to have
    | awesome classes like .w-2/3.
    |
    | Class name: .w-{size}
    |
    */
    width: {
      auto: 'auto',
      px: '1px',
      0: '0',
      30: '7.5rem',
      32: '8rem',
      49: '12.5rem',
      56: '14rem',
      '1/2': '50%',
      '1/3': 'calc(1/3*100%)',
      '1/4': '25%',
      '1/5': '20%',
      '1/6': 'calc(1/6*100%)',
      '1/7': 'calc(1/7*100%)',
      '1/8': '12.5%',
      '2/3': 'calc(2/3*100%)',
      '2/5': '40%',
      '3/4': '75%',
      '3/5': '60%',
      '3/10': '30%',
      '4/5': '80%',
      '5/6': 'calc(5/6*100%)',
      '7/10': '70%',
      '9/10': '90%',
      '12/25': '48%',
      full: '100%',
      screen: '100vw'
    },

    /*
    |-----------------------------------------------------------------------------
    | Height                                  https://tailwindcss.com/docs/height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your height utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based numeric scale plus some other
    | common use-cases. You can, of course, modify these values as
    | needed.
    |
    | Class name: .h-{size}
    |
    */
    height: {
      auto: 'auto',
      px: '1px',
      0: '0',
      2: '0.5rem',
      4: '1rem',
      8: '2rem',
      9: '2.25rem',
      10: '2.5rem',
      12: '3rem',
      13: '3.25rem',
      16: '4rem',
      20: '5rem',
      25: '6.25rem',
      32: '8rem',
      44: '11rem',
      64: '16rem',
      72: '18rem',
      full: '100%',
      screen: '100vh',
      '1/2': '50%'
    },

    /*
    |-----------------------------------------------------------------------------
    | Minimum width                        https://tailwindcss.com/docs/min-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your minimum width utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | couple common use-cases by default. You can, of course, modify
    | these values as needed.
    |
    | Class name: .min-w-{size}
    |
    */
    minWidth: {
      0: '0',
      '1/2': '50%',
      '1/3': 'calc(1/3*100%)',
      content: 'fit-content',
      full: '100%',
      auto: 'auto'
    },

    /*
    |-----------------------------------------------------------------------------
    | Minimum height                      https://tailwindcss.com/docs/min-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your minimum height utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | few common use-cases by default. You can, of course, modify these
    | values as needed.
    |
    | Class name: .min-h-{size}
    |
    */
    minHeight: {
      32: '8rem',
      full: '100%',
      screen: '100vh'
    },

    /*
    |-----------------------------------------------------------------------------
    | Maximum width                        https://tailwindcss.com/docs/max-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your maximum width utility sizes. These can
    | be percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based scale and a "full width" size,
    | which is basically a reset utility. You can, of course,
    | modify these values as needed.
    |
    | Class name: .max-w-{size}
    |
    */
    maxWidth: {
      content: 'fit-content',
      xs: '20rem',
      sm: '30rem',
      '2xl': '125rem',
      '1/4': '25%',
      '1/2': '50%',
      '2/5': '40%',
      '3/5': '60%',
      '4/5': '80%',
      '9/10': '90%',
      full: '100%',
      'site-mini': '36.875rem',
      'site-small': '49.1rem',
      'site-medium': '61.45rem',
      site: '73.75rem'
    },

    /*
    |-----------------------------------------------------------------------------
    | Maximum height                      https://tailwindcss.com/docs/max-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your maximum height utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | couple common use-cases by default. You can, of course, modify
    | these values as needed.
    |
    | Class name: .max-h-{size}
    |
    */
    maxHeight: {
      none: 'none',
      screen: '100vh',
      '50vh': '50vh',
      full: '100%'
    },

    /*
    |-----------------------------------------------------------------------------
    | Padding                                https://tailwindcss.com/docs/padding
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your padding utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default we
    | provide a sensible rem based numeric scale plus a couple other
    | common use-cases like "1px". You can, of course, modify these
    | values as needed.
    |
    | Class name: .p{side?}-{size}
    |
    */
    padding: _objectSpread({}, globalSpacing),

    /*
    |-----------------------------------------------------------------------------
    | Margin                                  https://tailwindcss.com/docs/margin
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your margin utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default we
    | provide a sensible rem based numeric scale plus a couple other
    | common use-cases like "1px". You can, of course, modify these
    | values as needed.
    |
    | Class name: .m{side?}-{size}
    |
    */
    margin: _objectSpread(_objectSpread({
      auto: 'auto',
      px: '1px',
      px2: '2px'
    }, globalSpacing), {}, {
      '-2px': '-2px'
    }, negativeGlobalSpacing),

    /*
    |-----------------------------------------------------------------------------
    | Shadows                                https://tailwindcss.com/docs/shadows
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your shadow utilities. As you can see from
    | the defaults we provide, it's possible to apply multiple shadows
    | per utility using comma separation.
    |
    | If a `default` shadow is provided, it will be made available as the non-
    | suffixed `.shadow` utility.
    |
    | Class name: .shadow-{size?}
    |
    */
    boxShadow: {
      "default": '0 2px 5px 0 rgba(0, 0, 0, 0.25)',
      xs: '1px 1px 5px 0 rgba(0,0,0,0.53)',
      sm: '0 1px 5px 0 rgba(0, 0, 0, .15)',
      md: '0 0 10px 0 rgba(0, 0, 0, 0.25)',
      lg: '0 0 20px rgba(0, 0, 0, 0.15)',
      diffuse: '0 10px 20px 0 rgba(0,0,0,0.05)',
      subtle: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      inset: 'inset 0 0 5px 0 rgba(0, 0, 0, 0.25)',
      none: 'none'
    },

    /*
    |-----------------------------------------------------------------------------
    | Z-index                                https://tailwindcss.com/docs/z-index
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your z-index utility values. By default we
    | provide a sensible numeric scale. You can, of course, modify these
    | values as needed.
    |
    | Class name: .z-{index}
    |
    */
    zIndex: {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
      'main-navigation': 7
    },

    /*
    |-----------------------------------------------------------------------------
    | Opacity                                https://tailwindcss.com/docs/opacity
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your opacity utility values. By default we
    | provide a sensible numeric scale. You can, of course, modify these
    | values as needed.
    |
    | Class name: .opacity-{name}
    |
    */
    opacity: {
      0: '0',
      10: '.1',
      25: '.25',
      50: '.5',
      75: '.75',
      100: '1'
    },

    /*
    |-----------------------------------------------------------------------------
    | SVG fill                                   https://tailwindcss.com/docs/svg
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your SVG fill colors. By default we just provide
    | `fill-current` which sets the fill to the current text color. This lets you
    | specify a fill color using existing text color utilities and helps keep the
    | generated CSS file size down.
    |
    | Class name: .fill-{name}
    |
    */
    fill: {
      current: 'currentColor',
      transparent: 'transparent'
    },

    /*
    |-----------------------------------------------------------------------------
    | SVG stroke                                 https://tailwindcss.com/docs/svg
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your SVG stroke colors. By default we just provide
    | `stroke-current` which sets the stroke to the current text color. This lets
    | you specify a stroke color using existing text color utilities and helps
    | keep the generated CSS file size down.
    |
    | Class name: .stroke-{name}
    |
    */
    stroke: {
      current: 'currentColor'
    }
  },

  /*
    |-----------------------------------------------------------------------------
    | Modules                  https://tailwindcss.com/docs/configuration#modules
    |-----------------------------------------------------------------------------
    |
    | Here is where you control which modules are generated and what variants are
    | generated for each of those modules.
    |
    | Currently supported variants:
    |   - responsive
    |   - hover
    |   - focus
    |   - active
    |   - group-hover
    |
    | To disable a module completely, use `false` instead of an array.
    |
    */
  variants: {
    accessibility: ['focus', 'responsive'],
    alignContent: [],
    alignItems: ['responsive'],
    alignSelf: ['responsive'],
    appearance: [],
    backgroundAttachment: [],
    backgroundColor: ['hover', 'focus'],
    backgroundPosition: [],
    backgroundRepeat: [],
    backgroundSize: [],
    borderCollapse: [],
    borderColor: ['hover', 'focus'],
    borderRadius: [],
    borderStyle: [],
    borderWidth: ['responsive'],
    boxShadow: ['responsive'],
    boxSizing: [],
    cursor: [],
    display: ['responsive'],
    fill: [],
    flexDirection: ['responsive'],
    flex: ['responsive'],
    flexGrow: ['responsive'],
    flexShrink: ['responsive'],
    flexWrap: ['responsive'],
    "float": [],
    fontFamily: [],
    fontSize: ['responsive'],
    fontSmoothing: [],
    fontStyle: [],
    fontWeight: [],
    height: ['responsive'],
    inset: ['responsive'],
    justifyContent: ['responsive'],
    letterSpacing: [],
    lineHeight: ['responsive'],
    listStylePosition: [],
    listStyleType: [],
    margin: ['responsive'],
    maxHeight: ['responsive'],
    maxWidth: ['responsive'],
    minHeight: ['responsive'],
    minWidth: ['responsive'],
    negativeMargin: ['responsive'],
    objectFit: [],
    objectPosition: [],
    opacity: ['hover', 'group-hover'],
    outline: [],
    overflow: ['responsive'],
    padding: ['responsive'],
    placeholderColor: [],
    pointerEvents: [],
    position: ['responsive'],
    resize: [],
    rotate: [],
    scale: [],
    skew: [],
    stroke: [],
    strokeWidth: [],
    tableLayout: [],
    textAlign: ['responsive'],
    textColor: ['focus', 'hover'],
    textDecoration: ['focus', 'hover'],
    textTransform: [],
    transformOrigin: [],
    transitionDuration: [],
    transitionProperty: [],
    transitionTimingFunction: [],
    translate: [],
    userSelect: [],
    verticalAlign: [],
    visibility: [],
    whitespace: ['responsive'],
    width: ['responsive'],
    wordBreak: [],
    zIndex: ['responsive']
  },
  corePlugins: {
    // animation: false, // v1.6
    backgroundAttachment: false,
    // backgroundClip: false, // v1.7
    // backgroundImage: false, // v1.7
    // backgroundOpacity: false, // v1.4
    // borderOpacity: false, // v1.4
    boxSizing: false,
    clear: false,
    // divideColor: false, // v1.3
    // divideOpacity: false, // v1.4
    // divideStyle: false, // v1.7
    // divideWidth: false, // v1.3
    fontSmoothing: false,
    // fontVariantNumeric: false, // v1.8
    gradientColorStops: false,
    // gridAutoColumns: false, // v1.9
    // gridAutoRows: false, // v1.9
    gridColumn: false,
    gridColumnStart: false,
    gridColumnEnd: false,
    gridRow: false,
    gridRowStart: false,
    gridRowEnd: false,
    // justifyItems: false, // v1.8
    // justifySelf: false, // v1.8
    listStylePosition: false,
    // objectFit: false,
    // objectPosition: false,
    // overscrollBehavior: false, // v1.6
    // placeContent: false, // v1.8
    // placeholderColor: false,
    // placeholderOpacity: false, // v1.4
    // placeItems: false, // v1.8
    // placeSelf: false, // v1.8
    resize: false,
    rotate: false,
    scale: false,
    skew: false,
    strokeWidth: false,
    // space: false, // v1.3
    // textOpacity: false, // v1.4
    transformOrigin: false,
    // transitionDelay: false, // v1.3
    transitionDuration: false,
    transitionProperty: false,
    transitionTimingFunction: false,
    translate: false
  }
};

/***/ }),

/***/ "ZNfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SiteContainer; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("Z79w");
/* harmony import */ var _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



var WIDTHS = {
  large: _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__["theme"].maxWidth.site,
  medium: _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__["theme"].maxWidth['site-medium'],
  small: _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__["theme"].maxWidth['site-small'],
  mini: _stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__["theme"].maxWidth['site-mini']
};
var GUTTERS = "".concat(_stylesheets_configs_tailwind_config__WEBPACK_IMPORTED_MODULE_3__["theme"].padding.px20, " * 2");
var SiteContainer = function SiteContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      id = _ref.id,
      isWide = _ref.isWide,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size;

  if (!react__WEBPACK_IMPORTED_MODULE_1__["Children"].count(children)) {
    return null;
  }

  var maxWidth = "calc(".concat(WIDTHS[size], " + ").concat(GUTTERS, ")");
  return isWide ? children : __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(className, 'mx-auto px-px20 relative site-container w-full'),
    id: id,
    style: {
      maxWidth: maxWidth
    }
  }, children);
};

/***/ }),

/***/ "d8WC":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "iQ7j":
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "peMk":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("iQ7j");

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "tGbD":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("iQ7j");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "twbh":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ })

}]);